import axios from 'axios'
import { apiUrl } from '@/config.js';


const axiosImpl = axios.create({
	baseURL: apiUrl,
	timeout: 100000,
	crossDomain: true,
	headers: {
		'Content-Type': 'application/json'
	}
})

axiosImpl.interceptors.request.use(
	(config) => {
		
		let token = JSON.parse(localStorage.getItem('token') );

		config.headers['Content-Type'] = 'application/json';
		config.headers['Access-Control-Allow-Credentials'] = 'true';
		config.headers['Access-Control-Expose-Headers'] = "Access-Control-*";
        config.headers['Access-Control-Allow-Headers'] = "Access-Control-*, Origin, X-Requested-With, Content-Type, Accept";
        config.headers['Access-Control-Allow-Methods'] = "GET, POST, PUT, DELETE, OPTIONS, HEAD";
        config.headers['Access-Control-Allow-Origin'] = "*";
		config.headers['Allow'] = "GET, POST, PUT, DELETE, OPTIONS, HEAD";
        config.headers['Cache-Control'] = 'no-cache'; 

		if(token){
			config.headers['Authorization'] = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

export default axiosImpl